"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var phocus_1 = require("phocus");
var action_1 = require("../action/action");
var phocus_context_1 = require("../phocus-context/phocus-context");
var action_search_1 = require("./action-search");
var command_palette_action_1 = require("./command-palette-action");
phocus_1.ActionContextService.addContext("command-palette", {
    actions: {
        doit: new action_1.Action({
            name: "Take the first action",
            defaultKeys: ["Enter"],
            actOn: function (component) {
                phocus_1.ActionContextService.triggerAction("closeModal");
                component.search()[0].act();
            }
        }),
        focusFirst: new action_1.Action({
            hidden: true,
            name: "Focus on the first action",
            defaultKeys: ["ArrowDown"],
            actOn: function (component) {
                phocus_1.focusInContext("action-0");
            }
        })
    }
});
var CommandPalette = /** @class */ (function (_super) {
    __extends(CommandPalette, _super);
    function CommandPalette() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            search: "",
            actions: []
        };
        return _this;
    }
    CommandPalette.prototype.componentWillMount = function () {
        this.setState({ actions: phocus_1.ActionContextService.availableActions });
    };
    CommandPalette.prototype.search = function () {
        return action_search_1.filterActions(this.state.actions, this.state.search);
    };
    CommandPalette.prototype.render = function () {
        var _this = this;
        return (React.createElement(phocus_context_1.PhocusContext, { context: "command-palette", argument: this, className: "phocus-command-palette" },
            React.createElement("div", { className: "phocus-command-palette--hint" }, "Hint: try opening this command palette while different things are focused."),
            React.createElement("input", { onChange: function (e) { return _this.setState({ search: e.target.value }); }, value: this.state.search }),
            this.search().map(function (a, i) { return (React.createElement(command_palette_action_1.CommandPaletteAction, { action: a, key: i, id: i })); })));
    };
    return CommandPalette;
}(React.Component));
exports.CommandPalette = CommandPalette;
//# sourceMappingURL=command-palette.js.map